module.exports = {
	"Allocation Funds": 683,
	"Alternative Funds": 1,
	"International Equity Funds": 1094,
	"Sector Equity Funds": 867,
	"U.S. Equity Fund": 2554
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersGroups.json
// module id = 953
// module chunks = 0